import { post } from "../fetch_utils"

export const archiveEvent = (eventId, archive) => {
  return post(`/events/${eventId}/archive`, {
    archive: archive,
  })
}

export const updateNotifications = (eventId, notificationsEnabled) => {
  return post(`/events/${eventId}/notifications`, {
    notificationsEnabled: notificationsEnabled,
  })
}
